import { render, staticRenderFns } from "./DocumentTypeDashboard.vue?vue&type=template&id=724bbb64&"
import script from "./DocumentTypeDashboard.vue?vue&type=script&lang=ts&"
export * from "./DocumentTypeDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports